export default __webpack_public_path__ + "static/media/walkthru-sha-bar.0f1950b7.svg";